import { Entri } from "./types";
import { CheckDomainResult } from "../../src/types/CheckDomainResult";

type EntriWindow = Window & { entri: Entri };

function initializeEntri(): Promise<Entri> {
  return new Promise((resolve, reject) => {
    const entriWindow = (window as unknown as EntriWindow).entri;
    if (entriWindow) {
      resolve(entriWindow);
      return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://cdn.goentri.com/entri.js";

    script.addEventListener("load", () => {
      resolve((window as unknown as EntriWindow).entri);
    });

    script.addEventListener("error", () => {
      reject(new Error("Failed to load the Entri SDK."));
    });

    document.body.appendChild(script);
  });
}

export const showEntri = async (config: Parameters<Entri["showEntri"]>[0]) => {
  const entri = await initializeEntri();
  return entri.showEntri(config);
};

export const checkDomain = async (
  domain: Parameters<Entri["checkDomain"]>[0],
  config: Parameters<Entri["checkDomain"]>[1]
): Promise<CheckDomainResult> => {
  const entri = await initializeEntri();
  return entri.checkDomain(domain, config);
};

export const purchaseDomain = async (
  config: Parameters<Entri["purchaseDomain"]>[0]
) => {
  const entri = await initializeEntri();
  return entri.purchaseDomain(config);
};

export const close = async () => {
  const entri = await initializeEntri();
  return entri.close();
};

export const load = async () => {
  return await initializeEntri();
};
